import { VAULT_PLAN_ID } from '@/app/lib/constants';
import type { User } from '@/app/lib/types/auth';

/**
 * Checks whether a user has access to the Vault (plan_id 11).
 * Same logic for ALL user roles — no role-based shortcuts.
 *
 * Access is granted if:
 * 1. user.membership?.id === VAULT_PLAN_ID (resolved membership from backend)
 * 2. OR user.orders contains at least one active order with package_id === VAULT_PLAN_ID
 *
 * The backend ensures admin users always have plan_id 11,
 * so they pass this same check naturally.
 */
export function hasVaultAccess(user: User | null): boolean {
  if (!user) return false;

  // Check resolved membership (may come from role default or latest active order)
  if (user.membership?.id === VAULT_PLAN_ID) {
    return true;
  }

  // Check orders for an active Vault order
  if (user.orders?.some(order => order.status === 'active' && order.package_id === VAULT_PLAN_ID)) {
    return true;
  }

  return false;
}
